import React, { Suspense } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { httpEditUser } from '../../../Hooks/admin/admin.put.hooks';
import PropTypes from 'prop-types';

// Lazy load components
const PrimaryButton = React.lazy(
  () =>
    import('../../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const Loader = React.lazy(
  () => import('../../../Components/Loader/LoaderComponent.component')
);

const EditUserSubmit = ({ user, type, setSuccessState }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (editedUser) => httpEditUser(user._id, editedUser),
    onSuccess: () => {
      queryClient.invalidateQueries(['users', 'employees', 'managers']);
      setSuccessState('User updated successfully');
      // setIsOpen(true);
    },
    onError: (error) => {
      console.error('Error updating user:', error);
      setSuccessState('Failed to update user');
      // setIsOpen(true);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessState('Updating user...');
    const editedUser = {
      ...user,
      ...(type && { type }),
    };
    mutation.mutate(editedUser);
  };

  return (
    <>
      {mutation.isLoading ? (
        <Suspense fallback={<p>Loading loader...</p>}>
          <Loader />
        </Suspense>
      ) : (
        <Suspense fallback={<p>Loading button...</p>}>
          <PrimaryButton
            functionName={(e) => handleSubmit(e)}
            span="Edit User"
          />
        </Suspense>
      )}
    </>
  );
};

EditUserSubmit.propTypes = {
  user: PropTypes.object,
  setSuccessState: PropTypes.func,
  type: PropTypes.string,
};

export default EditUserSubmit;
